import { Heading, Text } from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import SectionImage1 from '@/assets/gift-cards/section-1.png';
import SectionImage2 from '@/assets/gift-cards/section-2.png';
import SectionImage3 from '@/assets/gift-cards/section-3.png';
import MaxWidth from '@/components/common/layout/MaxWidth';

import { GiftCardSection, TGiftCardSection } from './GiftCardSection';

export const GiftCardSections = () => {
  const intl = useIntl();
  const sections: TGiftCardSection[] = [
    {
      title: intl.formatMessage({
        defaultMessage: 'Give them a chance to rent before they buy',
        id: 't3s73l',
      }),
      description: intl.formatMessage({
        defaultMessage:
          'Know someone thinking about buying a rig of their own? They can rent and compare a few before buying. Have a family member or friend that’s nervous to drive an RV? They can get it delivered to a campground or just about anywhere by a host who’ll set it up and show them the ropes.',
        id: 'RmI2SO',
      }),
      image: SectionImage1.src,
      isLeft: true,
    },
    {
      title: intl.formatMessage({
        defaultMessage: 'Thousands of RVs, infinite reasons to rent',
        id: 'tLnNqc',
      }),
      description: intl.formatMessage({
        defaultMessage:
          'Consider Outdoorsy your gateway to a world of adventure: rent an RV for your kid’s out of state sports tournament, tailgate at your favorite team’s stadium or at a NASCAR race, camp out at a music or craft festival, at a friends’ wedding, your family’s house for Thanksgiving, or plan a couple’s retreat, or a solo weekend away. Thinking about an international trip? We have rentals available in 11 countries to help with that.',
        id: 'IE6jQ+',
      }),
      image: SectionImage2.src,
      isLeft: false,
    },
    {
      title: intl.formatMessage({
        defaultMessage: "Camp or Glamp at one of Outdoorsy's Signature destinations",
        id: 'ld/r4k',
      }),
      description: intl.formatMessage({
        defaultMessage:
          'You can also redeem Outdoorsy gift cards for a campsite or accommodation reservation at one of Outdoorsy’s three signature properties; Outdoorsy Bayfield in SouthWest Colorado, Outdoorsy Yosemite in California, or enjoy luxury glamping at Outdoorsy Texas Hill Country.',
        id: 'LYmMuU',
      }),
      image: SectionImage3.src,
      isLeft: true,
    },
  ];

  return (
    <MaxWidth className="flex my-10 lg:mx-auto">
      <div className="flex flex-col mt-5 lg:mx-20 lg:items-center gap-5">
        <Heading className="font-bold lg:text-center leading-10 lg:leading-none text-[32px]">
          <FormattedMessage
            defaultMessage="Gift cards for the outdoorsy and indoorsy people in your life"
            id="/0w407"
          />
        </Heading>
        <Text className="text-gray-800 lg:text-center font-400">
          <FormattedMessage
            defaultMessage="Plan a night under the stars with an Outdoorsy gift card. Rent one of 36,000+ RVs, campervans and travel trailers from trusted local hosts in over 4,800 cities around the country. Filter by pet friendly and for amenities like kitchens, AC, bathrooms and showers to find the right fit for your adventure, whether you’re camping at your local state park or venturing hundreds of miles cross-country."
            id="aXmr+U"
          />
        </Text>
      </div>
      <div className="w-full mt-10 lg:my-10">
        {sections.map((section, index) => (
          <GiftCardSection key={index} {...section} />
        ))}
      </div>
    </MaxWidth>
  );
};
